export default __webpack_public_path__ + "media/images/tenant/timeline/step_4-eaa4b0aea7ce91fda26e048f4beb4acb.webp";